import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import './Growth.css';

const Growth = ({ title, text, cta }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="wealth-growth">
      <div className="wealth-growth__inner">
        <Reveal className="wealth-growth__content">
          <h2 className="wealth-growth__title">{title}</h2>
          {text ? <p className="wealth-growth__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="wealth-growth__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default Growth;
